export enum SocialIntakeFormState {
  FORM = 'form',
  ERROR = 'error',
  PROCESSING = 'processing'
}
